<!--TODO: Удалить компонент после того как везде заменим UiTable-->

<template>
  <div ref="wrapper">
    <div :key="tableKey">
      <slot :set-ref="setSlotRef" />
    </div>
  </div>
</template>

<script>
import sortable from 'sortablejs';

export default {
  name: 'SortableElTable',
  props: {
    handle: {
      type: String,
      default: '',
    },
    animate: {
      type: Number,
      default: 100,
    },
  },
  emits: ['drop', 'drag'],
  data() {
    return {
      tableKey: 0,
      datatableRef: null,
    };
  },
  watch: {
    tableKey() {
      this.$nextTick(() => {
        this.makeTableSortAble();
        this.keepWrapperHeight(false);
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.makeTableSortAble();
    });
  },
  methods: {
    setSlotRef(el) {
      this.datatableRef = el;
    },
    makeTableSortAble() {
      const table = this.datatableRef.$el.querySelector(
        '.el-table__body-wrapper tbody',
      );
      sortable.create(table, {
        handle: this.handle,
        animation: this.animate,
        onStart: () => {
          this.$emit('drag');
        },
        onEnd: ({ newIndex, oldIndex }) => {
          this.keepWrapperHeight(true);
          this.tableKey = Math.random();
          const arr = this.datatableRef.data;
          const targetRow = arr.splice(oldIndex, 1)[0];
          arr.splice(newIndex, 0, targetRow);
          this.$emit('drop', { targetObject: targetRow, list: arr });
        },
      });
    },
    keepWrapperHeight(keep) {
      // eslint-disable-next-line prefer-destructuring
      const wrapper = this.$refs.wrapper;
      if (keep) {
        wrapper.style.minHeight = `${wrapper.clientHeight}px`;
      } else {
        wrapper.style.minHeight = 'auto';
      }
    },
  },
};
</script>
